<template>
    <div id="page-text-fields">
        <v-container grid-list-xl fluid>
            <v-form @submit.prevent="handleSubmit" ref="form">
                <v-layout row wrap>
                    <v-flex sm12>
                        <v-widget title="تیکت جدید">
                            <div slot="widget-content">
                                <v-container>
                                    <v-layout>
                                        <v-flex>
                                            <v-text-field
                                                    label="عنوان درخواست"
                                                    name="title"
                                                    v-model="form.title"
                                                    type="text"
                                                    required
                                                    :rules="[rules.required]"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex>
                                            <v-autocomplete
                                                    label="دپارتمان"
                                                    :items="reseller_ticket_departments"
                                                    v-model="form.department_id"
                                                    autocomplete
                                                    auto
                                                    required
                                                    item-text="name"
                                                    :rules="[rules.required]"
                                                    item-value="dep_id"
                                            ></v-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <v-textarea
                                                    label=""
                                                    name="content"
                                                    v-model="form.content"
                                                    type="text"
                                                    rows="20"
                                                    maxlength="4096"
                                                    :rules="[rules.required]"
                                                    placeholder="متن درخواست خود را به زبان شیوای پارسی بنویسید..."
                                            ></v-textarea>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <div class="pt-2">پیوست(انتخاب تا ۱۰ فایل):</div>
                                        &nbsp;
                                        &nbsp;
                                        <v-tooltip top>
                                        <input
                                            slot="activator"
                                            name="attachment"
                                            ref="attachment"
                                            type="file"
                                            class="pt-2"
                                            multiple
                                        />
                                            <span>همزمان تا ۱۰ فایل را میتوانید انتخاب کنید </span>
                                        </v-tooltip>
                                        &nbsp;
                                        &nbsp;
                                        <v-chip>
                                            حداکثر ۵۰ مگابایت
                                        </v-chip>
                                        <v-chip>
                                            فرمت‌های مجاز (jpg,png,pdf,doc,docx,cdr,ai,svg,zip,rar)
                                        </v-chip>
                                    </v-layout>
                                    <v-layout>
                                        <v-btn
                                                :loading="loading"
                                                :disabled="loading"
                                                color="green"
                                                class="white--text"
                                                large
                                                @click="handleSubmit"
                                                type="button"
                                        >
                                            ثبت
                                            &nbsp;
                                            <v-icon left dark>save</v-icon>
                                        </v-btn>
                                    </v-layout>
                                </v-container>
                            </div>
                        </v-widget>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-container>
        <v-snackbar
                :timeout="snackbar.timeout"
                :color="snackbar.color"
                :top="snackbar.y === 'top'"
                :bottom="snackbar.y === 'bottom'"
                :right="snackbar.x === 'right'"
                :left="snackbar.x === 'left'"
                :multi-line="snackbar.mode === 'multi-line'"
                :vertical="snackbar.mode === 'vertical'"
                v-model="snackbar.snackbar"
        >
            {{ snackbar.text }}
            <v-btn flat icon dark @click.native="snackbar.snackbar = false">
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';

export default {
  components: {
    VWidget
  },
  data () {
    return {
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      form: {
        tid: 0,
        title: '',
        content: '',
        parent_id: 0,
        attachment: '',
        department_id: 1,
      },
      admins: [],
      reseller_ticket_departments: [],
      loader: null,
      loading: false,
      rules: {
        required: (value) => !!value || 'پر کردن این فیلد اجباری است.',
      }
    };
  },
  computed: {},
  mounted: function () {

    this.axios.get('/reseller/admins/')
      .then(response => {
        this.admins = response.data;
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });

    this.axios.get('/reseller/reseller_ticket_departments/')
      .then(response => {
        this.reseller_ticket_departments = response.data.Data;
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });


  },
  methods: {
    handleSubmit () {
      this.$validator.validateAll().then((isValidate) => {
        if (!this.$refs.form.validate()) {
          return;
        }
        if (isValidate) {
          let formData = new FormData();
          let fi = 0;
          while (typeof this.$refs.attachment.files[fi] !== 'undefined') {
            formData.append('attachment[' + fi + ']', this.$refs.attachment.files[fi]);
            fi++;
          }
          formData.append('data', JSON.stringify(this.form));
          this.loader = 'loading';
          this.loading = true;
          this.axios.post('/reseller/ticket',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then(response => {
            // Response Submit Method
            this.snackbar.text = 'با موفقیت انجام شد.';
            this.snackbar.y = 'bottom';
            this.snackbar.color = 'success';
            this.snackbar.snackbar = true;
            setTimeout(() => {
              this.$router.push('/pages/tickets/list');
            }, 3000);
          }).catch(error => {
            this.snackbar = HttpErrorToSnackbar(error);
            this.loading = false;
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/tickets/new.vue